import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ROUTES } from '../../pages/Home/const';
import { useNavigate } from 'react-router-dom';

const ReportsHeader = ({ title, backPath = ROUTES.REPORTS.INDEX, hideBack = false }) => {
  const navigate = useNavigate();

  return (
    <Box display="flex" alignItems="center" mb={2}>
      {!hideBack && (
        <IconButton onClick={() => navigate(backPath)} size="large">
          <ArrowBackIcon />
        </IconButton>
      )}
      <Typography variant="h5" sx={{ ml: 1 }}>
        {title}
      </Typography>
    </Box>
  );
};

export default ReportsHeader;
